module.exports = __webpack_public_path__ + "static/Ganaz-8277d9f21a7dd129c4c43488cdf81dfb.jpg";